import { compose } from '@fluentui/react-bindings';
import { commonPropTypes } from '../../utils';
import { Box } from '../Box/Box';
export var listItemContentClassName = 'ui-list__itemcontent';

/**
 * Provides a content for the ListItem.
 */
export var ListItemContent = /*#__PURE__*/function () {
  var ListItemContent = compose(Box, {
    className: listItemContentClassName,
    displayName: 'ListItemContent',
    mapPropsToStylesProps: function mapPropsToStylesProps(_ref) {
      var hasContentMedia = _ref.hasContentMedia,
        hasHeader = _ref.hasHeader,
        truncate = _ref.truncate;
      return {
        hasContentMedia: hasContentMedia,
        hasHeader: hasHeader,
        truncate: truncate
      };
    },
    handledProps: ['hasContentMedia', 'hasHeader', 'truncate'],
    overrideStyles: true,
    shorthandConfig: {
      mappedProp: 'content'
    }
  });
  ListItemContent.propTypes = commonPropTypes.createCommon();
  return ListItemContent;
}();
//# sourceMappingURL=ListItemContent.js.map
